/**
 * Constant: local config
 */
(function() {
        angular
        .module("app")
        .constant("ENV_CONFIG", {

                cookieDomain:  "www.dev.wancofleet.com",
                apiUrl:        "https://api.dev.wancofleet.com",
                label:         "FM Dev",
                showLabel:     true,
                pubNubPrefix:  "fm-dev",
                pubNubSubKey:  "sub-c-e438492e-0a7d-11e7-afb0-0619f8945a4f",
                fmPushEnabled: true,
		        fmPushWSUrl:   "wss://push.dev.wancofleet.com/ws",
		        fmPushSSEUrl:  "https://push.dev.wancofleet.com/events",
                mapsAPIKey:    "AIzaSyADpmitNyZSH9iiFi9ZWz2O4Irzu8eR_VY",
                debugConsole:  true,
                v2AppUrl:      "https://www.v2.dev.wancofleet.com"
        });
})();
